import type { FC, ReactNode } from "react";
import { cn } from "../../lib/utils";
import { Icon, type IconType } from "../../primitives/Icon";
import { Text } from "../../primitives/Text";

export type EmptyStateProps = {
	icon?: IconType;
	title?: ReactNode;
	message: ReactNode;
	action?: ReactNode;
	className?: string;
	testId?: string;
	trackingId?: string;
};

export const EmptyState: FC<EmptyStateProps> = ({
	icon,
	title,
	message,
	action,
	className,
	testId = "empty-state",
	trackingId,
}) => (
	<div
		className={cn(
			"flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center",
			className,
		)}
		data-testid={testId}
		data-tracking-id={trackingId}
	>
		{icon && <Icon color="subtle" data-testid={`${testId}-icon`} size="large" type={icon} />}
		{title && (
			<Text type="title" color="primary">
				{title}
			</Text>
		)}
		<Text type="body" color="tertiary">
			{message}
		</Text>
		{action}
	</div>
);
